import { CartLinesUpdateEvent } from '@shopify/events';

const dialog = document.getElementById('hercules-cart-confirmation');
if (dialog && !dialog.dataset.initialized) {
  dialog.dataset.initialized = 'true';
  let previousFocus;
  let quickTrigger;
  const pending = new WeakSet();
  const pendingVariants = new Set();
  const root = () => window.Shopify?.routes?.root || '/';
  const formLimit = (form) => {
    const raw = form.querySelector('select[name="id"]')?.selectedOptions[0]?.dataset.max ?? form.dataset.hcLimit;
    return raw != null && raw.trim() !== '' ? Number(raw) : Infinity;
  };
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('#hc-form')) return;
    const inputs = [...form.querySelectorAll('[data-hc-variant]')];
    for (const input of inputs) {
      input.setCustomValidity('');
      const limit = input.dataset.hcLimit === '' ? Infinity : Number(input.dataset.hcLimit);
      const total = inputs.filter(other => other.dataset.hcVariant === input.dataset.hcVariant).reduce((sum,other) => sum + Number(other.value),0);
      if (total > limit) { input.setCustomValidity(dialog.dataset.cartLimit); event.preventDefault(); event.stopImmediatePropagation(); input.reportValidity(); return; }
    }
  }, true);
  document.addEventListener('input', (event) => { if (event.target.matches?.('[data-hc-variant]')) event.target.form.querySelectorAll('[data-hc-variant]').forEach(input => input.setCustomValidity('')); });
  const categoryFor = (form) => {
    const section = form.closest('.hs-section');
    const homeCategory = section?.querySelector('a.hs-view')?.getAttribute('href');
    if (homeCategory) return homeCategory;
    if (window.location.pathname.includes('/collections/')) return window.location.pathname.split('/products/')[0];
    const page = form.closest('#hercules-product-page,.hercules-quick-options');
    return page?.querySelector('[data-hc-category]')?.getAttribute('href') || root() + 'collections/all';
  };
  const close = () => dialog.close();
  document.addEventListener('click', (event) => { const trigger = event.target.closest?.('quick-add-component button'); if (trigger) quickTrigger = trigger; }, true);
  dialog.querySelector('.hc-close').addEventListener('click', close);
  dialog.querySelector('.hc-continue').addEventListener('click', close);
  dialog.addEventListener('click', (event) => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close(); } });
  dialog.addEventListener('close', () => { if (previousFocus?.isConnected) previousFocus.focus(); });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add(?:$|[.?])/.test(new URL(form.action, location.origin).pathname)) return;
    if (event.submitter?.name === 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending.has(form) || !form.reportValidity()) return;
    const data = new FormData(form);
    if (!data.get('id')) return;
    const variantId = String(data.get('id'));
    if (pendingVariants.has(variantId)) return;
    pendingVariants.add(variantId);
    pending.add(form);
    const button = event.submitter || form.querySelector('button[type="submit"]');
    const oldLabel = button?.textContent;
    const wasDisabled = button?.disabled;
    const plainButton = button && !button.closest('add-to-cart-component');
    const error = form.querySelector('.hc-form-error') || document.createElement('p');
    error.className = 'hc-form-error'; error.setAttribute('role','alert'); error.textContent = '';
    if (!error.isConnected) form.append(error);
    if (button) { button.disabled = true; button.setAttribute('aria-busy','true'); if (plainButton) button.textContent = dialog.dataset.adding; }
    const category = categoryFor(form);
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(item => item.dataset.sectionId))].slice(0,5);
    if (sections.length) { data.set('sections',sections.join(',')); data.set('sections_url',location.pathname); }
    try {
      const currentResponse = await fetch(root() + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
      if (!currentResponse.ok) throw new Error(dialog.dataset.error);
      const currentCart = await currentResponse.json();
      const alreadyInCart = currentCart.items.filter(item => String(item.variant_id || item.id) === variantId).reduce((sum,item) => sum + item.quantity,0);
      const remaining = Math.max(0,formLimit(form) - alreadyInCart);
      if (Number(data.get('quantity') || 1) > remaining) throw new Error(dialog.dataset.stockLimit.replace('[remaining]',String(remaining)));
      const response = await fetch(root() + 'cart/add.js', { method:'POST', body:data, headers:{ Accept:'application/json' } });
      const item = await response.json();
      if (!response.ok || item.status) throw new Error(item.description || item.message || dialog.dataset.error);
      let cart;
      try { const result = await fetch(root() + 'cart.js', {headers:{Accept:'application/json'}}); if (result.ok) cart = await result.json(); } catch {}
      if (cart) {
        document.dispatchEvent(new CartLinesUpdateEvent({action:'update',context:'cart',lines:[],promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{sections:item.sections,items:cart.items,itemCount:cart.item_count,source:'hercules-cart-confirmation',didError:false}})}));
        document.querySelectorAll('.hx-cart').forEach(link => { link.textContent = link.textContent.replace(/\(\d+\)/,'(' + cart.item_count + ')'); });
      }
      const quickDialog = form.closest('dialog');
      previousFocus = quickDialog ? quickTrigger : button;
      if (quickDialog?.open) { document.querySelector('quick-add-modal')?.closeDialog?.(); if (quickDialog.open) quickDialog.close(); }
      dialog.querySelector('.hc-item').textContent = item.title || item.product_title || item.items?.[0]?.title || '';
      dialog.querySelector('.hc-more').setAttribute('href',category);
      if (!dialog.open) dialog.showModal();
    } catch (failure) {
      error.textContent = failure.message || dialog.dataset.error;
    } finally {
      pending.delete(form);
      pendingVariants.delete(variantId);
      if (button) { button.disabled = wasDisabled; button.removeAttribute('aria-busy'); if (plainButton) button.textContent = oldLabel; }
    }
  }, true);
}

